@let debugMode = debugMode$ | async;

<red-header></red-header>

<red-page-content [paddingBottom]="true">
  @if ((netSheetEnabled$ | async) && (calculatorsEnabled$ | async) ) {
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-divider color="primary">
      <ion-label>Calculators</ion-label>
    </ion-item-divider>
    <ion-item [routerLink]="['calculators', 'piti']" [detail]="true">
      <ion-label color="medium">PITI</ion-label>
      <ion-icon src="/assets/svg/piti.svg" slot="start"></ion-icon>
    </ion-item>
    <ion-item [routerLink]="['calculators', 'affordability']" [detail]="true">
      <ion-label color="medium">Affordability</ion-label>
      <ion-icon src="/assets/svg/affordability.svg" slot="start"></ion-icon>
    </ion-item>
    <ion-item [routerLink]="['calculators', 'amortization']" [detail]="true">
      <ion-label color="medium">Amortization</ion-label>
      <ion-icon src="/assets/svg/amortization.svg" slot="start"></ion-icon>
    </ion-item>
  </ion-list>
  }

  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-divider color="primary">
      <ion-label>Utilities</ion-label>
    </ion-item-divider>
    @if (orderTitleEnabled$ | async) {
    <ion-item (click)="openOrderTitle()" [detail]="true">
      <ion-label color="primary">Order Title</ion-label>
      <ion-icon color="primary" src="/assets/svg/order-title.svg" slot="start"></ion-icon>
    </ion-item>
    }
    <ion-item [routerLink]="['share-contact-info']" [detail]="true">
      <ion-label color="medium">Share Contact Info</ion-label>
      <ion-icon name="qr-code-outline" slot="start"></ion-icon>
    </ion-item>
  </ion-list>

  @if (monetizationEnabled$ | async) {
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-divider color="success">
      <ion-label>Purchases</ion-label>
    </ion-item-divider>
    @if (primarySubscriptionEnabled$ | async) { @let isPrimarySubscriptionActive = primarySubscriptionActive$ | async;

    <ion-item (click)="subscribe(isPrimarySubscriptionActive)">
      <ion-icon color="success" src="/assets/svg/lock-open.svg" slot="start"></ion-icon>
      <ion-label color="success">{{primarySubscriptionName$ | async}}</ion-label>
      <ion-badge slot="end" [redBooleanToSubscribed]="isPrimarySubscriptionActive"></ion-badge>
    </ion-item>
    }
    <ion-item>
      <ion-icon color="success" src="/assets/svg/coins.svg" slot="start"></ion-icon>
      <ion-label color="success">{{virtualCurrencyLabel}}</ion-label>
      <ion-badge slot="end" color="success">{{virtualCurrency$ | async | number}}</ion-badge>
    </ion-item>
    <ion-item [routerLink]="['store']" [detail]="true">
      <ion-label color="success">Store</ion-label>
      <ion-icon color="success" name="wallet-outline" slot="start"></ion-icon>
    </ion-item>
    @if (!isNativePlatform) {
    <ion-item [routerLink]="['store', 'subscriptions']" [detail]="true">
      <ion-label color="success">My Subscriptions</ion-label>
      <ion-icon color="success" name="card-outline" slot="start"></ion-icon>
    </ion-item>
    } @if (isNativePlatform) {
    <ion-item (click)="restorePurchases()">
      <ion-label color="success">Restore Purchases</ion-label>
      <ion-icon color="success" name="sync-outline" slot="start"></ion-icon>
    </ion-item>
    }
  </ion-list>
  }

  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-divider>
      <ion-label>Account Settings</ion-label>
    </ion-item-divider>
    <ion-item [routerLink]="['personal-details']" [detail]="true">
      <ion-label color="medium">Personal Details</ion-label>
      <ion-icon name="person-circle-outline" slot="start"></ion-icon>
    </ion-item>
    <ion-item [routerLink]="['login-credentials']" [detail]="true">
      <ion-label color="medium">Login Credentials</ion-label>
      <ion-icon name="key-outline" slot="start"></ion-icon>
    </ion-item>
    @if (farmAlertsEnabled$ | async) {
    <ion-item [routerLink]="['farm-alerts']" [detail]="true">
      <ion-label color="medium">Farm Alerts</ion-label>
      <ion-icon name="alarm-outline" slot="start"></ion-icon>
    </ion-item>
    }
  </ion-list>

  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-divider>
      <ion-label>Help & Support</ion-label>
    </ion-item-divider>
    <ion-item (click)="openUrl(tutorialsUrl)" [detail]="true">
      <ion-label color="medium">Tutorials</ion-label>
      <ion-icon name="book-outline" slot="start"></ion-icon>
    </ion-item>
    <ion-item (click)="openSupport()" [detail]="true">
      <ion-label color="medium">Support</ion-label>
      <ion-icon name="help-buoy-outline" slot="start">></ion-icon>
    </ion-item>
    <ion-item>
      <ion-toggle [checked]="(enableTooltips$ | async) === true" (click)="toggleTooltips($event)">
        <ion-text color="medium">Enable Tooltips</ion-text>
      </ion-toggle>
      <ion-icon name="chatbox-outline" slot="start">></ion-icon>
    </ion-item>
  </ion-list>

  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-divider>
      <ion-label>Legal</ion-label>
    </ion-item-divider>
    <ion-item (click)="openUrl('https://redshedtechnology.com/sdtutorials/privacy-policy.html')" [detail]="true">
      <ion-label color="medium">Privacy Policy</ion-label>
      <ion-icon name="finger-print-outline" slot="start"></ion-icon>
    </ion-item>
    <ion-item [routerLink]="['terms']" [detail]="true">
      <ion-label color="medium">Terms of Service</ion-label>
      <ion-icon name="receipt-outline" slot="start"></ion-icon>
    </ion-item>
  </ion-list>

  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-divider>
      <ion-label>Configuration</ion-label>
    </ion-item-divider>
    @if (showChangeIconOption && !disableChangeIconOption) {
    <ion-item>
      <ion-icon name="color-palette-outline" slot="start"></ion-icon>
      <ion-toggle (click)="changeIcon($event)" [checked]="hasDefaultIcon">Use default app icon</ion-toggle>
    </ion-item>
    } @if (useMobileLayout$ | async) {
    <ion-item [routerLink]="['permissions']">
      <ion-icon name="cog-outline" slot="start"></ion-icon>
      <ion-label>Permissions</ion-label>
    </ion-item>
    @if (debugMode) {
    <ion-item (click)="reset()" [detail]="true">
      <ion-label color="danger">Reset</ion-label>
      <ion-icon color="danger" name="log-out-outline" slot="start"></ion-icon>
    </ion-item>
    } } @else {
    <ion-item (click)="reset()" [detail]="true">
      <ion-label color="danger">Logout</ion-label>
      <ion-icon color="danger" name="log-out-outline" slot="start"></ion-icon>
    </ion-item>
    } @if (debugMode) {
    <ion-item [routerLink]="['debug']">
      <ion-icon color="warning" name="bug-outline" slot="start"></ion-icon>
      <ion-label color="warning">Debug</ion-label>
    </ion-item>
    }
    <ion-item (click)="toggleDebugMode()">
      <ion-icon color="medium" name="information-circle-outline" slot="start"></ion-icon>
      <ion-label color="medium">{{environment}} Version</ion-label>
      <ion-note slot="end">{{appVersion$ | async}}</ion-note>
    </ion-item>
  </ion-list>
</red-page-content>
